import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { i18n } from '../i18n';
import {sumBy, min} from 'lodash';
import { comm } from '../comm';
import { integration } from "../integration";
import { ButtonMover } from './Buttons';
import { ProgressBar } from './ProgressBar';
import { Sprite } from './Sprite';

const AchievementBody = styled.div`
	flex: 0 0 17.5vw;
	overflow: auto;
	text-align: center;
	color: black;
	&::-webkit-scrollbar { width: 0 !important }
	display: flex;
	flex-direction: row;
	background-image: url('/assets/achievements/achievements_panel.png');
	background-size: 100% 100%;
	padding: 4vw;
	padding-top: 2vw;
	margin-bottom: 0.5vw;
`

const Left = styled.div`
	flex-basis: 250px;
	flex-grow: 1;
	text-align: left;
	overflow: hidden;
	box-sizing: border-box;
`
const Right = styled.div`
	flex: 0 0 27vw;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	flex-direction: row;
	color: white;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	font-size: 4.5vw;
	position:relative;
	margin-left: 3vw;
`

const AchName = styled.div`
	color: white;
	font-size: 5vw;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	white-space: nowrap;
	line-height: 1.2em;
`

const AchDesc = styled.div`
	color: white;
	font-size: 3.5vw;
	text-shadow: 0.3vw 0.3vw 0.3vw black;
	white-space: nowrap;
	line-height: 1.2em;
`

const Trophy = styled.img`
	width: 27vw;
`

const Xp = styled.div`
	position: absolute;
	bottom: 0;
	display: block;
	width: 100%;
	text-align: center;
	font-size: 4vw;
`

const Bar = styled.div`
 height: 6vw;
 margin-top: 1vw;
`

@observer
export class AchievementItem extends Component {

	state = {
		claiming: false
	};

	claimReward(reward, color, xp){
		// window.manager.playAudio("poopPop");
		this.setState({claiming: true});
		comm.ConfirmNotification(reward.ConfirmationKey)
		.then(() => {
			integration.postAnalyticsEvent(`achievement_collect_xp`, `economy`, xp);
			return store.user.updateXp();
		})
		.then(() => {
			return integration.processNotifications();
		})
		.then(() => {
			this.setState({claiming: false});
			store.showAchRewardBanner = [color, parseInt(xp,10)];
		});
	}

	render(){
		var a = store.user.achievements[this.props.i];
		const rewards = store.rewardsByAch[a.Current.Type] || [];
		const canClaim = rewards.length > 0;
		const start = sumBy(a.Start,'Quantity');
		const next = canClaim ? start : sumBy(a.Next,'Quantity') - start;
		const progress = canClaim ? start : sumBy(a.Progress,'Quantity') - start;
		const reward = canClaim ? rewards[0].Data.xp : sumBy(a.NextRewards,'Quantity');
		const percent = canClaim ? 100 : next <= 0 ? 0 : progress / next * 100;
		const color = ["bronze","silver","gold"][min([(a.Current.Quantity - canClaim ? 1 : 0), 2])];
		// console.log('color',color, parseInt(a.Current.Quantity, 10), min([parseInt(a.Current.Quantity, 10), 2]));

		//hide if there are no more rewards to claim in this achievement
		if((!canClaim && progress >= a.Current.MaxQuantity) || (!canClaim &&  next <= 0)){
			return null;
		}

		var style = {order: Math.floor(101 - percent)};
		// console.log('order', style.order)
		return (
			<AchievementBody style={style}>
				<Left>
					<AchName style={{flexBasis: 200}}>{i18n.t('ach-'+a.Current.Type)}</AchName>
					<AchDesc style={{flexBasis: 200}}>{i18n.t('ach-'+a.Current.Type+'-desc')}</AchDesc>
					<div><Bar>
						<ProgressBar yellow percent={percent}>
							{rewards.length > 0 ? i18n.t('completed') : `${progress}/${next}`}
						</ProgressBar>
					</Bar></div>
				</Left>
				<Right>
					{canClaim ? (
						<ButtonMover onClick={this.claimReward.bind(this, rewards[0], color, reward)}>
							<div style={{position: 'relative', top: '0vw'}}>
								<Sprite w={27} localize sprite="btn_collect.png"/>
							</div>
						</ButtonMover>
					) : (
						<React.Fragment>
							<Trophy alt={`${color} trophy`} src={`/assets/achievements/achievements_trophy_${color}.png`}/>
							<Xp>{reward} XP +</Xp>
						</React.Fragment>
					)}
				</Right>
			</AchievementBody>
		)
	}
}
